import { env } from 'next-runtime-env';

import { TokenManager } from '~shared/services/ClientTokenManager';

import type { Markers, UpdateRegistrationMarkersParams } from './types';

const origin = env('NEXT_PUBLIC_PUBLIC_API') ?? 'https://api.ifriend.ai';

const getUrl = (userId: string) => `${origin}/analytics/${userId}/registration`;

export const getRegistrationMarkersAsync = async (
	userId: string
): Promise<Markers> => {
	const { token } = TokenManager.getInfo();

	if (!token) {
		throw new Error('No token available for annals registration');
	}

	const response = await fetch(getUrl(userId), {
		method: 'GET',
		keepalive: true,
		headers: {
			authorization: `Token token="${token}"`,
		},
	});

	if (!response.ok) {
		throw new Error('Failed to fetch registration data');
	}

	return response.json() as Promise<Markers>;
};

export const updateRegistrationMarkersAsync = async (
	params: UpdateRegistrationMarkersParams
): Promise<void> => {
	const { token } = TokenManager.getInfo();

	if (!token) {
		throw new Error('No token available for annals registration');
	}

	const response = await fetch(getUrl(params.userId), {
		method: 'PUT',
		body: JSON.stringify(params.data),
		keepalive: true,
		headers: {
			authorization: `Token token="${token}"`,
		},
	});

	if (!response.ok) {
		throw new Error(
			`Failed to update registration markers: ${response.status}`
		);
	}
};
